import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonWithIcon } from '@ff-os/shared-react/components/buttons/button-with-icon/ButtonWithIcon';
import { urls } from '@ff-os/shared-utils/urls';
import classNames from 'classnames';
import { selectisFotofunPanelOpen, setisFotofunPanelOpen } from '../../_redux-ui';
import styles from './FotofunBanner.module.scss';

export const FotofunBanner = () => {
    const dispatch = useDispatch();

    const isFotofunPanelOpen = useSelector(selectisFotofunPanelOpen);

    const toggleFotofunPanel = () => {
        dispatch(setisFotofunPanelOpen(!isFotofunPanelOpen));
    };

    const { t } = useTranslation();

    return (
        <div className={styles.fotofunBanner} onClick={toggleFotofunPanel}>
            <div className={styles.fotofunContent}>
                <p className={styles.label}>
                    {t('photo_prints.magic_frame_new')}
                </p>
                <h4 className={styles.title}>{t('photo_prints.magic_frame_title')}</h4>
                <p className={styles.copy}>
                    {t('photo_prints.magic_frame_text')}
                </p>
                <ButtonWithIcon small
                    icon='general-ui-chevron-right'
                    position='right-small'
                    strokeWidth={2}
                    className={styles.button}>
                    {t('photo_prints.magic_frame_button')}
                </ButtonWithIcon>
            </div>

            <div className={styles.maskedContainer}>
                <div className={classNames(styles.imagePlaceholder, styles.imagePlaceholderOne)}>
                    <img src={urls.publicAssetUrl("6fe37ff6-97a3-404f-919b-9e5220e790bf")} className={classNames(styles.girl, styles.girl1)} />
                    <img src={urls.publicAssetUrl("3e56c3bf-d025-4361-89f1-e0b44248c713")} className={classNames(styles.girl, styles.girl2)} />
                    <img src={urls.publicAssetUrl("a4ea83d2-d8c0-49a1-81f2-bb46cd450ce9")} className={classNames(styles.girl, styles.girl3)} />
                    <img src={urls.publicAssetUrl("dc893f2f-d694-4830-b9c9-2a93c0f177b2")} className={classNames(styles.girl, styles.girl4)} />
                    <img src={urls.publicAssetUrl("f262bd78-4cbb-410d-8826-a6f72eca27e9")} className={classNames(styles.girl, styles.girl5)} />
                </div>
                <div className={classNames(styles.imagePlaceholder, styles.imagePlaceholderTwo)}>
                    <img src={urls.publicAssetUrl("89a6a730-61b3-48f7-84f9-c930057b3532")} className={classNames(styles.women, styles.women1)} />
                    <img src={urls.publicAssetUrl("542fa1ef-893a-462b-85db-95a3ab4d7b39")} className={classNames(styles.women, styles.women2)} />
                    <img src={urls.publicAssetUrl("9ae3fb71-9b28-4c2e-8e8f-f422d2259015")} className={classNames(styles.women, styles.women3)} />
                    <img src={urls.publicAssetUrl("8cecf01c-c200-4c69-8bf5-ea6697e95d54")} className={classNames(styles.women, styles.women4)} />
                    <img src={urls.publicAssetUrl("252a9189-26b3-486c-beef-a64d56215bba")} className={classNames(styles.women, styles.women5)} />
                </div>
            </div>
        </div>
    );
};